import { render } from "./HeroiconsSolidPause.vue?vue&type=template&id=9873253c"
const script = {}

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPause.vue"]])

export default __exports__